import endpoint from "../../config/endpoints";

export const CarryForwardLeaveProcessJson = {
    showSaveNextBtn: true,
    formPath: "/holiday-structure-form",
    apiBaseURL: endpoint.carryForwardLeaveHeader,
    changeExcel: endpoint.exportData,
    screenTitle: "Carry Forward Leave Process",
    showAddButton: true,
    showPdfDownload: true,
    pdfFileName: "Holiday Structure",
    showExcelDownload: true,
    excelFileName: "Holiday Structure",
    formPathView: "/carry-forward-process-view",
    isActiveURL: endpoint.holidayStructureHeader + "/update-is-active",
    openFormPathStatus: "/carry-forward-leave-assignation-process",


    tableColumnsToFilter: [
        {
            columnDisplayName: "Emp Code",
            columnKeyName: "empCode",
            isChecked: true,
        },
        {
            columnDisplayName: "Sales Team Name",
            columnKeyName: "salesTeamName",
            isChecked: true,
        },
        {
            columnDisplayName: "Sales Team Type",
            columnKeyName: "salesTeamType",
            isChecked: true,
        },
        {
            columnDisplayName: "Reporting Type",
            columnKeyName: "reportingManagerType",
            isChecked: true,
        },
        {
            columnDisplayName: "Reporting Name",
            columnKeyName: "reportingManagerName",
            isChecked: true,
        },
    ],
    fieldMeta: [
        {
            label: "Leave Year",
            controlType: "autocomplete",
            placeHolder: "Select Leave Year",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            masterName: "leaveYearMasterDetail",
            dataKey: "leaveYearId",
            getListId: "leaveYearId",
            isRootLevelKey: true,
            isMandatory: true,
        },
    ],
};
